import React, { Suspense, useMemo } from 'react';
import { Button, Content, PortalOverlay } from '@leverege/ui-elements';
import { DecodeHintType, BarcodeFormat } from '@zxing/library';
import I18N from '@leverege/i18n';
import { CodeInput, CodeScanner } from '@leverege/ui-scanner-elements';
import S from './ScanSearch.css';
import LoadingScreen from "../../../support/LoadingScreen.js";
import ScanTextHandlerFactory from "./ScanTextHandlerFactory.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.screens.group.ScanSearch');
const SCAN_TYPES = {
  aztec: 'AZTEC',
  codabar: 'CODABAR',
  code_128: 'CODE_128',
  code_39: 'CODE_39',
  code_93: 'CODE_93',
  data_matrix: 'DATA_MATRIX',
  ean_13: 'EAN_13',
  ean_8: 'EAN_8',
  itf: 'ITF',
  maxicode: 'MAXICODE',
  pdf_417: 'PDF_417',
  rss_14: 'RSS_14',
  rss_expanded: 'RSS_EXPANDED',
  upc_a: 'UPC_A',
  upc_e: 'UPC_E',
  upc_ean_extension: 'UPC_EAN_EXTENSION'
};
export default function ScanSearch(props) {
  const {
    show,
    onClose,
    context,
    fullScreen,
    scanAttrs
  } = props;
  const {
    onSearchChange
  } = context;
  const onError = err => {/* ignore */};
  const onScan = evt => {
    let nText;
    if (typeof evt?.value?.text === 'string') {
      nText = evt?.value?.text;
    } else if (typeof evt?.value?.[0]?.text === 'string') {
      nText = evt.value[0].text.trim();
    }
    if (nText) {
      scanAttrs.forEach((attr, index) => {
        nText = ScanTextHandlerFactory.create(attr?.blueprint?.attribute?.metadata?.scanTextHandler, nText, attr);
      });
      onSearchChange?.({
        value: nText
      });
      onClose();
    }
  };
  const opts = useMemo(() => {
    const opts = new Map();
    const formats = new Set([BarcodeFormat.QR_CODE // Always add this for backward compatibility
    ]);
    scanAttrs.forEach(attr => {
      const type = attr?.source?.attribute?.getTagStartingWith('scannable:', true);
      if (type && SCAN_TYPES[type] && BarcodeFormat[SCAN_TYPES[type]]) {
        formats.add(BarcodeFormat[SCAN_TYPES[type]]);
      }
    });
    opts.set(DecodeHintType.POSSIBLE_FORMATS, Array.from(formats));
    return opts;
  }, [scanAttrs]);
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    variant: "scanner",
    show: show,
    onClose: onClose,
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Content, {
        className: fullScreen ? null : S.content,
        relative: !fullScreen,
        children: /*#__PURE__*/_jsxs(Content.Area, {
          className: S.scannerContainer,
          children: [/*#__PURE__*/_jsx(LoadingScreen, {
            className: S.background
          }), /*#__PURE__*/_jsx(Button, {
            icon: tIcon('xIcon', 'fa fa-times fa-fw'),
            onClick: onClose,
            className: S.scannerClose,
            variant: "secondaryIconic"
          }), /*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx("div", {
              children: "Loading..."
            }),
            children: /*#__PURE__*/_jsx(CodeScanner, {
              zxOpts: opts,
              scanMilliseconds: 500,
              className: S.scanner,
              onChange: onScan,
              onError: onError,
              width: "100%",
              height: "100%",
              style: {
                objectFit: 'cover'
              }
            })
          }), /*#__PURE__*/_jsx(Suspense, {
            fallback: /*#__PURE__*/_jsx("div", {
              children: "Loading..."
            }),
            children: /*#__PURE__*/_jsx(CodeInput, {
              zxOpts: opts,
              variant: "upload",
              onChange: onScan,
              onError: onError,
              className: S.scannerUpload,
              children: t('upload')
            })
          })]
        })
      })
    })
  });
}